import { render, staticRenderFns } from "./EModalDuplicarAulaInfantil.vue?vue&type=template&id=15d94716&scoped=true"
import script from "./EModalDuplicarAulaInfantil.vue?vue&type=script&lang=js"
export * from "./EModalDuplicarAulaInfantil.vue?vue&type=script&lang=js"
import style0 from "./EModalDuplicarAulaInfantil.vue?vue&type=style&index=0&id=15d94716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d94716",
  null
  
)

export default component.exports